//Definimos la culture
moment.locale(LOCALE);

// if ('<?php echo $sf_user->getCulture(); ?>' == 'es_ES') {
//     applyButton = "Aceptar";
//     cancelButton = "Cancelar";
// }else if ('<?php echo $sf_user->getCulture(); ?>' == 'ca_ES') {
//     applyButton = "Aceptar";
//     cancelButton = "Cancelar";
// }else if ('<?php echo $sf_user->getCulture(); ?>' == 'en_US'){
//     applyButton = "Accept";
//     cancelButton = "Cancel";
// }else if ('<?php echo $sf_user->getCulture(); ?>' == 'fr_FR'){
//     applyButton = "Accepte";
//     cancelButton = "Annuler";
// }

var d = new Date();

//Al inicio lo dejaremos en blanco si ya viene de otra página con información
// $('input[data-name="datePickerTextDesktop"]').val('');
// $('input[data-name="datePickerTextMobile"]').val('');

var startDate = $('input[name="datapicker"]').val();
var endDate = $('input[name="datapickerOut"]').val();

//Para garantizar que hay valores para inicializar los calendarios
if(startDate == '' || endDate == ''){
    var day_start = d.getDate()  < 10 ? '0' + d.getDate()  : d.getDate();
    var month_start = (d.getMonth() + 1)  < 10 ? '0' + (d.getMonth() + 1)  : (d.getMonth() + 1);
    startDate = day_start + "/" + month_start + "/" + d.getFullYear();

    var d_end = d;
    d_end.setDate(d_end.getDate() + 2);
    var day_end = d_end.getDate()  < 10 ? '0' + d_end.getDate()  : d_end.getDate();
    var month_end = (d_end.getMonth() + 1)  < 10 ? '0' + (d_end.getMonth() + 1)  : (d_end.getMonth() + 1);
    endDate = day_end + "/" + month_end + "/" + d_end.getFullYear();

    $('input[name="datapicker"]').val(startDate);
    $('input[name="datapickerOut"]').val(endDate);

    if ($("#slopes-search-date")[0]) {
        $("#slopes-search-date").text(day_start + "/" + month_start + ' - ' + day_end + "/" + month_end);
    }
}

// console.log([startDate, endDate]);
//Start DataRangePicker para formularios
$('#inputDate').daterangepicker({
    "autoUpdateInput" : false,
    "applyButtonClasses": "btn btn-custom-lg bg-custom-secondary text-white",
    "minDate": d.getDate()+"/"+d.getMonth()+"/"+d.getFullYear(),
    "maxSpan": {
        "days": 7
    },
    "autoApply": false,
    "locale": {
        "format": 'ddd, DD MMM',
        "applyLabel": translations.accept,
        "cancelLabel": translations.cancel,
    }
});


//Por defecto ocultamos la fecha que aparece debajo de los botones
$('.drp-selected').hide();

//Agregamos el valor con el formato deseado
$('#inputDate').on('apply.daterangepicker', function(ev, picker) {
    $(this).val(picker.startDate.format('ddd DD MMM') + ' - ' + picker.endDate.format('ddd DD MMM'));
});

//Limpiamos el valor al cancelar
$('#inputDate').on('cancel.daterangepicker', function(ev, picker) {
    $(this).val('');
});

$('#inputDate').on('show.daterangepicker', function(ev, picker) {
    if ($(window).width() < 576) {
        $('body').addClass("modal-open");
        $('.daterangepicker').addClass("position-fixed");
    }
});

$('#inputDate').on('hide.daterangepicker', function(ev, picker) {
    if ($(window).width() < 576) {
        $('body').removeClass("modal-open");
        $('.daterangepicker').removeClass("position-fixed");
    }
});

//End DataRangePicker para formularios
